// extracted by mini-css-extract-plugin
export default {"fitPageHeight":"login_fitPageHeight__mg8Wa","loginWrapper":"login_loginWrapper__16TJ9","LoginDivider":"login_LoginDivider__b8U-7","backgroundImg":"login_backgroundImg__qNABy"};